// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=26f5f60e-2375-427a-b366-cca4b269ae35";
};